import type { WordTimestamp } from "../../client";

export type ElevenLabsAlignment = {
  chars: string[];
  charStartTimesMs: number[];
  charDurationsMs: number[];
};

export const decodePcm16ToFloat32 = (base64Audio: string): Float32Array => {
  const binaryString = atob(base64Audio);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const view = new DataView(bytes.buffer);
  const numSamples = bytes.length / 2;
  const output = new Float32Array(numSamples);
  for (let i = 0; i < numSamples; i++) {
    output[i] = view.getInt16(i * 2, true) / 32768;
  }
  return output;
};

export const alignmentToWordTimestamps = (
  alignment: ElevenLabsAlignment
): WordTimestamp[] => {
  const words: WordTimestamp[] = [];
  let currentWord = "";
  let wordStartMs = 0;
  let wordEndMs = 0;

  for (let i = 0; i < alignment.chars.length; i++) {
    const char = alignment.chars[i];
    if (char === " " || char === "\n" || char === "\t") {
      if (currentWord) {
        words.push({
          word: currentWord,
          start: wordStartMs / 1000,
          end: wordEndMs / 1000,
        });
        currentWord = "";
      }
    } else {
      if (!currentWord) {
        wordStartMs = alignment.charStartTimesMs[i];
      }
      currentWord += char;
      wordEndMs = alignment.charStartTimesMs[i] + alignment.charDurationsMs[i];
    }
  }

  if (currentWord) {
    words.push({
      word: currentWord,
      start: wordStartMs / 1000,
      end: wordEndMs / 1000,
    });
  }

  return words;
};
